// Spec rev82 (2026-08-02) — raccourci clavier "/" pour focus la barre de
// recherche. Actif globalement sur la page mais bloqué si l'utilisateur
// est déjà en train de taper dans un champ (input/textarea/contenteditable)
// ou si des modifieurs sont pressés (Ctrl/Cmd/Alt/Meta) — la barre "/"
// française nécessite juste la touche brute sans Shift.
import { useEffect } from "react";

/**
 * @param {() => (HTMLElement | null | undefined)} getTarget
 *   Fonction qui retourne l'élément à focus (input de recherche).
 */
export default function useSearchShortcut(getTarget) {
  useEffect(() => {
    const isTypingContext = (el) => {
      if (!el) return false;
      const tag = (el.tagName || "").toUpperCase();
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
      if (el.isContentEditable) return true;
      return false;
    };
    const onKey = (e) => {
      if (e.key !== "/") return;
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      if (isTypingContext(e.target) || isTypingContext(document.activeElement)) return;
      const node = getTarget && getTarget();
      if (!node) return;
      e.preventDefault();
      node.focus();
      if (typeof node.select === "function") {
        try { node.select(); } catch { /* ignore */ }
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [getTarget]);
}
